import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import useTranslations from '@hooks/useTranslation';
import { IColors, IConferenceItem } from '../../interfaces/Conference';
import { calendarApi } from '../../services/calendar.service';
import { RowSectionLecturerName, RowSectionLecturerPosition, WrapperLecturer } from './ConferenceProgram.elements';

interface ConferenceProps {
    colors?: IColors;
    personKey?: string;
    conf?: IConferenceItem;
}

const ConferenceProgramLecturerTemplate: FC<ConferenceProps> = ({ colors, personKey, conf }) => {
    const { t } = useTranslations();

    const [person, setPerson] = useState({});

    const loadPersonByKey = async (personKey: string) => {
        const lect = conf?.lectors.filter((item) => item?._from.split('/')[1] === personKey);
        setPerson(lect[0]);
    };

    useEffect(() => {
        if (personKey) {
            loadPersonByKey(personKey);
        }
    }, [personKey]);

    return (
        <WrapperLecturer>
            <RowSectionLecturerName>
                {person?.titles?.before_name &&
                    `${person?.titles?.before_name} `
                }
                {person?.name} {person?.surname}
                {person?.titles?.after_name &&
                    `, ${person?.titles?.after_name}`
                }
            </RowSectionLecturerName>
            <RowSectionLecturerPosition>
                {person?.company}
                {person?.position?.length > 0 && person?.company?.length > 0 && <>, </>}
                {person?.position}
            </RowSectionLecturerPosition>
        </WrapperLecturer>
    );
};

export default ConferenceProgramLecturerTemplate;
